import { jsxs, jsx } from "react/jsx-runtime";
import "../../../constants/index.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import Dialog from "../Dialog/Dialog.js";
import Button from "../../inputs/Button/Button.js";
const Prompt = ({
  children,
  classes,
  className,
  variant,
  size,
  withCancelButton = true,
  withConfirmButton = true,
  messages,
  onConfirm,
  onCancel,
  onClose,
  title,
  content,
  open = false,
  dialogClasses,
  zIndex
}) => {
  const { themeClasses } = useThemePresetClasses("Prompt", classes, className, {
    variant,
    modifier: size
  });
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      open,
      onClose,
      classes: dialogClasses,
      transition: true,
      title,
      className: cn(themeClasses == null ? void 0 : themeClasses.root),
      zIndex,
      children: [
        /* @__PURE__ */ jsx("div", { className: cn("mb-6 text-center text-base", themeClasses == null ? void 0 : themeClasses.content), children: content }),
        /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-x-2", children: [
          withCancelButton && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "secondary",
              onClick: (e) => {
                onCancel == null ? void 0 : onCancel(e);
                onClose();
              },
              className: "max-w-[100px] capitalize",
              size: "sm",
              children: messages == null ? void 0 : messages.cancel
            }
          ),
          withConfirmButton && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "primary",
              onClick: onConfirm,
              className: "max-w-[100px] capitalize",
              size: "sm",
              children: messages == null ? void 0 : messages.confirm
            }
          )
        ] })
      ]
    }
  );
};
const Prompt$1 = Prompt;
export {
  Prompt$1 as default
};
